<form [formGroup]="formGroup">
    <div class="row">
        <div id="searchResults" class="col-8">
            <sl-input
                tagId="streetField"
                type="text"
                placeholderKey="Address.Street"
                (blur)="onAnyFieldBlur()"
                [control]="formGroup.controls['street']" />
        </div>
        <div class="col-4">
            <sl-input
                type="text"
                placeholderKey="Address.StreetNumber"
                (blur)="onAnyFieldBlur()"
                [control]="formGroup.controls['streetNumber']" />
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-md-8">
            <sl-input
                type="text"
                placeholderKey="Address.StreetSupplement"
                (blur)="onAnyFieldBlur()"
                [control]="formGroup.controls['streetSupplement']" />
        </div>
        <div class="col-12 col-md-4 checkbox-wrapper">
            <mat-checkbox [formControl]="formGroup.controls['streetAfterSupplement'] | formControl" (change)="onAnyFieldBlur()">
                {{ 'Address.StreetAfterSupplement' | translate }}
            </mat-checkbox>
        </div>
    </div>
    <div class="row">
        <div class="col-4 checkbox-wrapper">
            <mat-checkbox [formControl]="formGroup.controls['isPoBox'] | formControl" (change)="onAnyFieldBlur()">
                {{ 'Address.PoBox' | translate }}
            </mat-checkbox>
        </div>
        <div class="col-8">
            <sl-input type="text" placeholderKey="Address.PoBoxNr" (blur)="onAnyFieldBlur()" [control]="formGroup.controls['poBox']" />
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-4">
            <sl-input
                type="text"
                placeholderKey="Address.ZipCode"
                (blur)="zipCodeBlur()"
                [control]="formGroup.controls['locationZipCode']" />
        </div>
        <div class="col-12 col-md-8">
            <mat-form-field class="w-100">
                <input
                    matInput
                    type="text"
                    placeholder="{{ 'Address.City' | translate }}"
                    [formControl]="cityControl"
                    [matAutocomplete]="autoCity"
                    (focusout)="cityFieldBlur()" />
                <sl-form-field-error-control [control]="cityControl" />
                @if (cityControl.value && !cityControl.disabled) {
                    <button mat-icon-button matSuffix (click)="clearCity()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
                <mat-autocomplete autoActiveFirstOption #autoCity="matAutocomplete" (optionSelected)="selectLocation($event.option.id)">
                    @for (loc of filteredLocations; track loc.id) {
                        <mat-option [value]="loc.city" [id]="loc.id">{{ loc.zipCode }} - {{ loc.city }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        @if (shouldAddLocation) {
            <div class="col-12">
                <button mat-button (click)="addNewLocation()">
                    {{ 'Address.AddLocation' | translate }}
                </button>
            </div>
        }
    </div>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="w-100">
                <input
                    matInput
                    type="text"
                    placeholder="{{ 'Address.Country' | translate }}"
                    [formControl]="countryControl"
                    (blur)="countryBlur()"
                    [matAutocomplete]="autoCountry" />
                <sl-form-field-error-control [control]="countryControl" />
                @if (countryControl.value && !countryControl.disabled) {
                    <button mat-icon-button matSuffix (click)="clearCountry()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
                <mat-autocomplete
                    autoActiveFirstOption
                    #autoCountry="matAutocomplete"
                    (optionSelected)="selectCountry($any($event.option))">
                    @for (country of filteredCountries; track country.id) {
                        <mat-option [value]="country.name" [id]="country.id">
                            {{ country.name }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
